module.exports = __webpack_public_path__ + "static/media/guidepoint_black.dc40a162.png";